__turbopack_context__.v({
  "countdown-spinner": "ItcavW_countdown-spinner",
  "countdown-spinner-container": "ItcavW_countdown-spinner-container",
  "countdown-spinner__circle": "ItcavW_countdown-spinner__circle",
  "countdown-spinner__count": "ItcavW_countdown-spinner__count",
});
